// To use Contentful, create a .env file in your project root with:
// REACT_APP_CONTENTFUL_SPACE_ID=your_space_id
// REACT_APP_CONTENTFUL_ACCESS_TOKEN=your_access_token

import { createClient } from 'contentful';

const CONTENTFUL_SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const CONTENTFUL_ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

const contentfulClient =
  CONTENTFUL_SPACE_ID && CONTENTFUL_ACCESS_TOKEN
    ? createClient({
        space: CONTENTFUL_SPACE_ID,
        accessToken: CONTENTFUL_ACCESS_TOKEN,
      })
    : null;

if (!CONTENTFUL_SPACE_ID || !CONTENTFUL_ACCESS_TOKEN) {
  // eslint-disable-next-line no-console
  console.warn('Contentful Space ID or Access Token not set. Blog functionality will be limited. Set them in a .env file.');
}

export default contentfulClient; 